import * as React from "react";

import { useLocalization } from "@shared-ui/localization-context";
import { UitkEmptyState } from "uitk-react-empty-state";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkHeading, UitkText } from "uitk-react-text";

import { PackageWizardState } from "stores/wizard/state";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutFlex } from "uitk-react-layout-flex";

export interface PackageErrorStateProps {
  lobsMissing?: number;
  packageWizardState: PackageWizardState;
}

export const PackageErrorStateHotwire: React.FunctionComponent<PackageErrorStateProps> = ({ packageWizardState }) => {
  const { formatText } = useLocalization();

  const heading = formatText("wizard.package.invalid.header.selectTwoOrMore.text");
  const body = formatText("wizard.package.invalid.body.toStartBuilding.text");
  const { updateInvalidFormsState } = packageWizardState;

  updateInvalidFormsState();

  return (
    <UitkSpacing margin={{ blockend: "four" }}>
      <UitkLayoutFlex justifyContent="center" className="error">
        <UitkEmptyState>
          <UitkIcon name="search" size={UitkIconSize.LARGE} />
          <UitkHeading tag="h2" size={7}>
            {heading}
          </UitkHeading>
          <UitkText>{body}</UitkText>
        </UitkEmptyState>
      </UitkLayoutFlex>
    </UitkSpacing>
  );
};
